var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitleGroups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4091_47518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.04151C0 0.525506 0.432 0.0935059 0.948 0.0935059H18.24C18.768 0.0935059 19.2 0.525506 19.2 1.04151V16.4135C19.2 16.9415 18.768 17.3615 18.252 17.3615H0.948C0.432 17.3735 0 16.9415 0 16.4255V1.04151ZM5.76 2.01351V15.4535H13.44V2.01351H5.76ZM1.92 2.01351V3.93351H3.84V2.01351H1.92ZM15.36 2.01351V3.93351H17.28V2.01351H15.36ZM1.92 5.85351V7.77351H3.84V5.85351H1.92ZM15.36 5.85351V7.77351H17.28V5.85351H15.36ZM1.92 9.69351V11.6135H3.84V9.69351H1.92ZM15.36 9.69351V11.6135H17.28V9.69351H15.36ZM1.92 13.5335V15.4535H3.84V13.5335H1.92ZM15.36 13.5335V15.4535H17.28V13.5335H15.36Z",
    fill: "#787E82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0528 6.81348H20.5208V8.73348H22.0928V10.6535H20.5208V12.5735H22.0928V14.4935H20.5208V16.4135H22.0928V18.3335H20.5208V18.3455C20.5208 18.8735 20.0888 19.2935 19.5728 19.2935H18.2528V22.1735H10.5608V19.2935H4.80078V23.1455C4.80078 23.6615 5.23278 24.0935 5.74878 24.0935H23.0408C23.5688 24.0935 23.9888 23.6615 23.9888 23.1455V7.76148C24.0008 7.24548 23.5688 6.81348 23.0528 6.81348ZM8.64078 22.1735H6.72078V20.2535H8.64078V22.1735ZM22.0808 22.1735H20.1608V20.2535H22.0808V22.1735Z",
    fill: "#525256"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4091_47518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.0935059)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleGroups);
export default __webpack_public_path__ + "static/media/TitleGroups.0b1ac4f2cb0a696cf81a9bed22b61463.svg";
export { ForwardRef as ReactComponent };